import Config from './utils/Config';
import SoundManager from './utils/SoundManager';
import IntroView from './controls/Intro';

export default class Intro {

    create()
    {
        const intro = new IntroView(this.game);
        let introMusic = null;

        if (SoundManager.music)
        {
            introMusic = SoundManager.playMusic('music/intro-music');
            if (!introMusic.isDecoded)
            {
                let timer = setInterval(() =>
                {
                    if (introMusic.isDecoded)
                    {
                        clearInterval(timer);
                        introMusic.play();
                    }
                    else
                    {
                        introMusic.update();
                    }
                }, 500);
            }
        }

        intro.onSkip.addOnce(() =>
        {
            if (introMusic)
            {
                introMusic.stop();
                SoundManager.remove(introMusic);
            }

            this.state.start('Game');
        });
    }

    shutdown()
    {
        [
            'intro.slide1', 'intro.slide2', 'intro.slide3',
            'intro.arrow-left', 'intro.arrow-right'
        ].forEach((key) =>
        {
            this.game.cache.removeImage(key);
        });

        this.game.cache.removeSound('music/intro-music');
    }
}